import { en, es, pt } from '@/locales'
import * as ls from '@/services/localStorage'
import { defineStore } from 'pinia'
import { createI18n } from 'vue-i18n'
import { computed } from 'vue'

type MessageSchema = typeof pt & typeof en & typeof es

const languageKey = process.env.VUE_APP_LS_LANGUAGE_KEY || 'VUE_APP_LS_LANGUAGE_KEY'

export const useLanguageStore = defineStore('language', () => {
  const i18n = createI18n<
    {
      message: MessageSchema
    },
    'pt' | 'en' | 'es'
  >({
    locale: ls.get(languageKey) || 'pt',
    inheritLocale: true,
    messages: {
      pt: pt as MessageSchema,
      en: en as MessageSchema,
      es: es as MessageSchema,
    },
  })

  const changeLanguage = (value: (typeof i18n.global.availableLocales)[number]) => {
    ls.set(languageKey, value)
    i18n.global.locale = value
  }

  const locale = computed(() => i18n.global.locale)
  const lang = computed(() => i18n.global.locale)

  return {
    lang,
    t: i18n.global.t,
    tc: i18n.global.tc,
    locale,
    availableLocales: i18n.global.availableLocales,
    changeLanguage,
  }
})
